import { AssetSelectionBladeModalProps } from 'components/containers/load-board/AssetSelectionBlade.tsx'
import { RootState } from 'state/store.ts'
import { PaymentRestrictionsBladeProps } from 'components/containers/bills/components/PaymentRestrictionsBlade'
import { SyncLogInfoBladeProps } from 'components/containers/ledger/components/SyncLogInfo.tsx'
import { AddEditUserBladeProps } from 'components/containers/settings/users/AddEditUserBlade'
import { ConfigureRoleBladeProps } from 'components/containers/settings/roles-and-permissions/ConfigureRoleBlade'

/**
 * generic form modal properties selector
 * casts the props to the type you want
 */
export const selectModalProps = <T>(state: RootState): T => {
  return state.ui.formModalProps as T
}

/**
 * lets you select the props for the asset selection blade modal in a type safe way
 * @param state
 */
export const selectAssetSelectionBladeProps = (state: RootState): AssetSelectionBladeModalProps => {
  return selectModalProps<AssetSelectionBladeModalProps>(state)
}

export const selectPaymentRestrictionsBladeProps = (state: RootState): PaymentRestrictionsBladeProps => {
  return selectModalProps<PaymentRestrictionsBladeProps>(state)
}

export const selectSyncLogInfoModalProps = (state: RootState) => {
  return selectModalProps<SyncLogInfoBladeProps>(state)
}

export const selectAddEditUserBladeProps = (state: RootState) => {
  return selectModalProps<AddEditUserBladeProps>(state)
}
export const selectConfigureRoleBladeProps = (state: RootState) => {
  return selectModalProps<ConfigureRoleBladeProps>(state)
}
